export const formatQueryString = (props: {
  offset?: number;
  limit?: number;
  order?: string;
  sort?: string;
  filter?: Record<string, unknown> | Record<string, unknown>[] | string | null;
  filterObject?: boolean;
}): string => {
  const { offset, limit, order, sort, filter, filterObject } = props;
  let query = "";

  if (offset) {
    query += `&offset=${offset}`;
  }

  if (limit) {
    query += `&limit=${limit}`;
  }

  if (order) {
    query += `&sort=${order}`;

    if (sort) {
      query += `%7C${sort}`;
    }
  }

  if (filter) {
    if (typeof filter === "string") {
      query += `&filter=${filter}`;
    } else {
      Object.keys(filter).forEach(key => {
        if (![undefined, null, ""].includes(filter[key] as string)) {
          if (filterObject) {
            if (Array.isArray(filter[key])) {
              const arr = filter[key] as string[];

              if (arr.length === 1) {
                query += `&filter[${key}][]=${arr[0]}`;
              } else {
                arr.forEach((i: string) => {
                  query += `&filter[${key}]=${i}`;
                });
              }
            } else {
              query += `&filter[${key}]=${filter[key]}`;
            }
          } else {
            query += `&${key}=${filter[key]}`;
          }
        }
      });
    }
  }

  if (query) {
    query = `?${query.slice(1)}`;
  }

  return query;
};
